import React, { useContext, useState } from 'react'
import UserContext from '../state/UserContext'
import { Button } from '@mui/material'
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import { documentToSVG, elementToSVG, inlineResources, formatXML } from 'dom-to-svg'

import download from 'downloadjs';

const ScreenDebug = (props) => {

    const { user } = useContext(UserContext)
    const permissions = user.permissions || []
    const roles = user.roles || []
    const [show, setShow] = useState(false)
    const [hidden, setHidden] = useState(false)

    const takeScreenSVG = async () => {
        const svgDocument = elementToSVG(document.getElementById('root'))
        await inlineResources(svgDocument.documentElement)
        const svgString = new XMLSerializer().serializeToString(svgDocument)
        download(svgString, 'goback-screenshot.svg')
    }

    const takeScreenPNG = async () => {
        try {
            setHidden(true)
            await new Promise(resolve => setTimeout(resolve, 1000));
            htmlToImage
                .toPng(document.getElementById('root'))
                .then((dataUrl) => download(dataUrl, 'goback-screenshot.png'));
        } finally {
            setHidden(false)
        }
    }


    if (process.env.NODE_ENV === "production") return null

    if (hidden) return null


    return (
        <div className="" style={{ color: "red" }}>
            <span className="fixed z-50 " style={{ color: "red" }}>
                <span className="z-50 block sm:hidden">XS</span>
                <span className="z-50 hidden sm:block md:hidden">SM</span>
                <span className="z-50 hidden md:block lg:hidden">MD</span>
                <span className="z-50 hidden lg:block xl:hidden">LG</span>
                <span className="z-50 hidden xl:block 2x1:hidden">XL</span>
                <span className="z-50 hidden 2x1:block">2xl</span>
            </span>
            <div className="fixed z-50 bottom-1 left-1" style={{ color: "red" }}>
                <Button onClick={() => setShow(!show)}>Show Debug</Button>
                {show && <>
                    <div className="text-sm">Roles: {roles.map(r => r.role).join(", ")}</div>
                    <div className="text-sm max-w-6xl">Permissions: {permissions.map(p => `${p.project}:${p.permission}`).join(", ")}</div>
                    <div>
                        <Button onClick={takeScreenSVG} className="!text-xs">Take screen SVG</Button>
                    </div>
                    <div>
                        <Button onClick={takeScreenPNG} className="!text-xs">Take screen PNG</Button>
                    </div>
                </>}
            </div>
        </div>
    )
}
export default ScreenDebug